import Grid from '@mui/material/Grid';
import AnalysisConditionsTable from 'pages/Evaluation/Product/ScenariosManagement/AnalysisConditionsTable';
import AnalysisDescriptorsTable from 'pages/Evaluation/Product/ScenariosManagement/AnalysisDescriptorsTable';
import Conditions from 'pages/Evaluation/Product/ScenariosManagement/ConditionsTable';
import Descriptors from 'pages/Evaluation/Product/ScenariosManagement/DescriptorsTable';
import React, { useState } from 'react';
import { PROC } from 'utils/constants/descriptorTypes';
import { TABLE_HEIGHT_SPLIT_4VIEW } from 'utils/ui/constants';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_4VIEW(0);

const Component = props => {
  const { augmentedConditionsByDescriptorId, augmentedDescriptors, lcs, scenario, productId } = props;

  const [descriptorId, setDescriptorId] = useState(null);
  const [analysisDescriptorId, setAnalysisDescriptorId] = useState(null);

  return (
    <Grid container>
      <Grid size={7}>
        <Descriptors
          descriptorId={descriptorId}
          setDescriptorId={setDescriptorId}
          descriptorFilter={PROC}
          scenario={scenario}
          productId={productId}
          lcs={lcs}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid size={5}>
        <AnalysisDescriptorsTable
          augmentedDescriptors={augmentedDescriptors}
          descriptorId={analysisDescriptorId}
          setDescriptorId={setAnalysisDescriptorId}
          TABLE_HEIGHT={TABLE_HEIGHT}
        />
      </Grid>
      <Grid size={7}>
        <Conditions
          descriptorFilter={PROC}
          descriptorId={descriptorId}
          conditionsFilter={'Trabalhadores'}
          scenario={scenario}
        />
      </Grid>
      <Grid size={5}>
        <AnalysisConditionsTable
          descriptorId={analysisDescriptorId}
          augmentedConditionsByDescriptorId={augmentedConditionsByDescriptorId}
        />
      </Grid>
    </Grid>
  );
};

export default Component;
